module.exports = __webpack_public_path__ + "img/empty.e04712a9.png";